import api, { extractError } from "api/api";

export const createCustomerSession = () => {
  return api
    .post(`/api/v2/stripe_memberships`)
    .then((resp) => resp.data.client_secret)
    .catch((e) => {
      throw extractError(e);
    });
};

export const cancelSubscription = () => {
  return api
    .delete(`/api/v2/stripe_memberships`)
    .then((resp) => resp.data.url)
    .catch((e) => {
      throw extractError(e);
    });
};

export const syncSubscriptions = () => {
  return api
    .get(`/api/v2/stripe_memberships`)
    .then((resp) => resp.data)
    .catch((e) => {
      throw extractError(e);
    });
};
